import { useWidget } from '@telescope/cassini-hooks';
import { AspectRatio, Image, Stack, Box, Heading } from '@telescope/cassini-ui';
import { AdUnit, Link, Text } from 'components';
import { Open, Winner } from 'generated-types/widget';
import { VoteOption } from 'types';

export const VoteOptionDetail = ({
  voteOption,
  voteButton,
}: {
  voteOption: VoteOption | null;
  voteButton?: React.ReactElement;
}) => {
  const {
    data: { ads },
  } = useWidget<Open | Winner>({ select: (data) => data.widget });

  if (!voteOption) return null;

  return (
    <Box className="VoteOptionDetail" data-vote-option-name={voteOption.name}>
      <Stack alignItems="center" spacing={3} mb={5}>
        <Box width="100%">
          {voteOption.videoEmbed ? (
            <AspectRatio ratio={16 / 9} className="VoteOptionDetail__video-embed">
              <iframe title={voteOption.name} src={voteOption.videoEmbed} allow="fullscreen"></iframe>
            </AspectRatio>
          ) : (
            <Image
              className="VoteOptionDetail__img"
              src={voteOption.image}
              fallbackSrc="https://ts-cms-production.votenow.tv/campaign/10/05/1005594/166026158062f594cc76f661.02211738.jpg"
              width="100%"
            />
          )}
          <Stack className="VoteOptionDetail__details-container" alignItems="center" spacing={3} p={5} pb={0}>
            <Heading className="VoteOptionDetail__heading" as="h1" size="lg" m={0} textAlign="center">
              {voteOption.name}
            </Heading>
            <Text className="VoteOptionDetail__description" allowMarkdown textAlign="center">
              {voteOption.description1}
            </Text>
            <Link
              className="VoteOptionDetail__link"
              href={voteOption.externalLinkHref}
              target="_blank"
              variant="emphasized">
              {voteOption.externalLinkText}
            </Link>
          </Stack>
        </Box>
        {voteButton}
      </Stack>
      <AdUnit mx="auto" my={[0, 5]} size="mobileBanner" {...ads.voteModal.mobileBanner} />
    </Box>
  );
};
